import mitt from 'mitt'
export default new mitt()
